var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Born"},[_c('div',{ref:"Gif",class:[
  '-GIF', 
  {'-play': _vm.playGIF},
  _vm.gifURL.indexOf('childhood') != -1 ? '-last-gif' : '' ],style:(_vm.gifStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }